import React from 'react'

export default function BillingOrder() {
    return (
        <div>
            This is order
        </div>
    )
}
    